import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/firestore';


// Staging
if (process.env.NODE_ENV !== 'development') { // When we release the tool, we should switch the database (for better name understanding)
  firebase.initializeApp({
    apiKey: "AIzaSyBRgs-PnY2wQOthwphy6Uo62NDBQTuyZ9I",
    authDomain: "easy-grader-sodexo-digital-cse.firebaseapp.com",
    databaseURL: "https://easy-grader-sodexo-digital-cse-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "easy-grader-sodexo-digital-cse",
    storageBucket: "easy-grader-sodexo-digital-cse.appspot.com",
    messagingSenderId: "793002628365",
    appId: "1:793002628365:web:15f4fa0738fc0a6d124c44",
    measurementId: "G-V6818HBVFL"
  });
}

// Production
if (process.env.NODE_ENV === 'development') {
  firebase.initializeApp({
    apiKey: "AIzaSyBRgs-PnY2wQOthwphy6Uo62NDBQTuyZ9I",
    authDomain: "easy-grader-sodexo-digital-cse.firebaseapp.com",
    databaseURL: "https://easy-grader-sodexo-digital-cse-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "easy-grader-sodexo-digital-cse",
    storageBucket: "easy-grader-sodexo-digital-cse.appspot.com",
    messagingSenderId: "793002628365",
    appId: "1:793002628365:web:15f4fa0738fc0a6d124c44",
    measurementId: "G-V6818HBVFL"
  });
}

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js